import { QuickFiltersValueDisplayUses } from '../../types/quickFilters/QuickFiltersValueDisplayUses';
import FormattedMessage from 'I18n/components/FormattedMessage';
import QuickFiltersTags from './QuickFiltersTags';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickFiltersNumberValueDisplay = props => {
  const {
    condition,
    onValueDelete,
    use
  } = props;
  const {
    name,
    value,
    highValue
  } = condition;
  const label = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `customerDataFiltersUI.quickFilters.filterOperatorTranslations.DURATION_NUMBER.${name}`,
    options: {
      value,
      highValue
    }
  });
  if (use === QuickFiltersValueDisplayUses.STRING) {
    return label;
  }
  const tags = [{
    value: name,
    label
  }];
  return /*#__PURE__*/_jsx(QuickFiltersTags, {
    tags: tags,
    onTagClose: () => onValueDelete()
  });
};
export default QuickFiltersNumberValueDisplay;